<template>
  <div class="ux-issue-wrap">
    <div class="data-panel issue-panel">
      <ue :pd="ues.pd" :content="ues.content" v-if="$service.PROJ_CODE==='l28' || $service.PROJ_CODE==='demo'"></ue>
      <div class="data-panel-header">
        <h2>问题清单</h2>
        <div class="extra"><a href="https://docs.popo.netease.com/lingxi/f5c9e1b292224344a9e271141075c8a3?xyz=1713934979682&tab=1" target="__blank">问题清单在线文档</a></div>        
      </div>      
      <div class="data-panel-content">
        <div class="filter-wrap">
          <div class="filter">
            <label class="ux-filter-title">日期</label>
            <a-radio-group v-model="filter.date" style="margin-right: 4px;" button-style="solid">
              <a-radio-button v-for="pdate in options.dates" :key="pdate.value" :value="pdate.id">{{pdate.label}}</a-radio-button>
            </a-radio-group>        
            <a-range-picker :value="date_range_value" @change="(v) => changeFilterDate(v)" :disabled-date="disabledRangeDate" :allowClear="false" v-if="$service.PROJ_CODE!='l28'"/>
            <RangePicker :value="date_range_value" :defaultValue="date_range_value" @change="(v) => changeFilterDate(v)"  v-else style="width:300px; display: inline-block;"/>
          </div>
          <div class="filter" style="flex:1; text-align: right;">
            <a-button @click="download">下载</a-button>
          </div>
        </div>
        <div class="filter-wrap">
          <div class="filter">
            <label class="ux-filter-title">玩法</label>
            <a-select mode="multiple" placeholder="搜索" :options="options.mode" style="min-width:200px" v-model="filter.mode"></a-select>
          </div>
          <div class="filter">
            <label class="ux-filter-title">负责人</label>
            <a-select mode="multiple" placeholder="搜索" :options="options.designer" style="min-width:200px" v-model="filter.designer"></a-select>
          </div>
          <div class="filter">
            <label class="ux-filter-title">来源</label>
            <a-select mode="multiple" placeholder="搜索" :options="options.type" style="min-width:200px" v-model="filter.type"></a-select>
          </div>
          <div class="filter">
            <label class="ux-filter-title">阻碍等级</label>
            <a-select mode="multiple" placeholder="搜索" :options="options.obstacleN" v-model="filter.obstacle" style="min-width:200px; margin-right: 4px;" ></a-select>
          </div>
          <div class="filter">
            <label class="ux-filter-title">当前进度</label>
            <a-select mode="multiple" placeholder="搜索" :options="options.progressN"  v-model="filter.progress" style="min-width:200px; margin-right: 4px;"></a-select>
          </div>
        </div>
        <IssueTable :data="dataSource" :progressOptions="progressOptions" :meta="meta" type="issue" @update="updateIssueList" ref="issueTable"/>
      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment";
import { isNil } from 'lodash';
import RangePicker from "@/components/common/search/range_picker.vue";
import ue from "./ue.vue";
import IssueTable from "./issueTable.vue";

export default {
  name: 'UxIssuePanel',
  props: {
    api: {
      type: String,
    },
    title: {
      type: String,
      default: '问题清单'
    }
  },  
  components: {
    RangePicker,
    ue,
    IssueTable
},
  data() {
    return {
      ues: {
        pd: [{name: '刘颖', email: 'hzliuying1@corp.netease.com'}],
        content: [{name: '曾国芬', email: 'hzzengguofen@corp.netease.com'}]
      },
      loading: false,
      filter: {
        date: '',
        obstacle: [],
        progress: [],
        mode: [],
        designer: [],
        type: [],
      },
      issueList: [],
      pagination: {
        pageSize: 30,
        showSizeChanger: true,
        showQuickJumper: true,
        size: "middle",
      },
      init: true,
      editItem: undefined,
      dataColumns: [
        { title: '模式', dataIndex: 'mode', width: 80 },
        // { title: '位置', dataIndex: 'position', width: 80 },
        { title: '阻碍等级', dataIndex: 'obstacle', width: 64, scopedSlots: { customRender: 'obstacle' }, sorter: (prev, next) => (prev.obstacleOrder - next.obstacleOrder) },
        { title: '问题描述', dataIndex: 'description', scopedSlots: { customRender: 'remark' }, width: '50%' },
        { title: '反馈频次', dataIndex: 'frequency', width: 64, sorter: (prev, next) => (prev.frequency - next.frequency) },
        { title: '对应功能解决', dataIndex: 'solution', scopedSlots: { customRender: 'solution' }, width: '30%' },
        // { title: '决策者回复', dataIndex: 'delivery', width: 200, scopedSlots: { customRender: 'delivery' } },
        { title: '当前进度', dataIndex: 'progress', width: 140, scopedSlots: { customRender: 'progress' }, sorter: (prev, next) => (prev.progressOrder - next.progressOrder) },
        { title: '反馈时间', dataIndex: 'format_time', width: 64, sorter: (prev, next) => (prev.time - next.time) },
        { title: '操作', scopedSlots: { customRender: 'operator' }, width: 64 },
      ],
      meta: {
        obstacle: [],
        progress: [],
      }
    }
  },
  mounted() {
    this.getExperienceIssue();
  },
  computed: {
    date_range_value() {
      const value = this.filter.date
      if(value && value!='') {
        const [start_dt, end_dt] = value.split('|');
        return [moment(start_dt), moment(end_dt)];
      }
      else {
        return [];
      }
    },
    dataSource() {
      console.log('update datasource')
      let [start_date, end_date] = this.filter.date && this.filter.date!=''?this.filter.date.split('|'):[null, null]
      if(start_date==null) {
        start_date = '2000-01-01'
      }
      if(end_date==null) {
        end_date = '2999-12-31'
      }

      const { obstacleMap, progressMap } = this.options;

      const wrapIssueList = this.issueList.map(issue => {
        return {
          ...issue,
          format_time: isNil(issue.time) ? '-' : moment(issue.time).format('MM/DD'),
          format_update_time: isNil(issue.update_time) ? '-' : moment(issue.update_time).format('MM/DD HH:mm'),
          obstacleOrder: obstacleMap[issue.obstacle]?.order || -1,
          progressOrder: progressMap[issue.progress]?.order || -1,
          obstacleColor: obstacleMap[issue.obstacle]?.color || `#c4c4c4`,
          progressColor: progressMap[issue.progress]?.color || `#c4c4c4`,
        }
      })
      const filterIssueList = wrapIssueList.filter(issue => {
        const f_obstacle = this.filter.obstacle==null || this.filter.obstacle.length === 0 ? true : this.filter.obstacle.indexOf(issue.obstacle)>=0;
        const f_progress = this.filter.progress==null || this.filter.progress.length === 0 ? true : this.filter.progress.indexOf(issue.progress)>=0;
        const f_type = this.filter.type==null || this.filter.type.length === 0 ? true : this.filter.type.indexOf(issue.type) >= 0;
        const f_mode = this.filter.mode==null || this.filter.mode.length === 0 ? true : this.filter.mode.indexOf(issue.mode) >= 0;
        const f_daterange = isNil(issue.time) ? true : moment(issue.time).isBetween(start_date, end_date, 'day', '[]');
        let f_designer = this.filter.designer==null || this.filter.designer.length === 0 ? true : this.filter.designer.indexOf(issue.designer) >= 0;
        if(f_designer===false) {
          this.filter.designer.forEach(fd=>{
            if(issue.designer && issue.designer.indexOf(fd)>=0) {
              f_designer = true
            }
          })
        }
        return f_obstacle && f_progress && f_mode && f_daterange && f_designer && f_type;
      });
      // custom Sort =>
      const sortedIssueList = filterIssueList.sort((prev, next) => {
        const t = 10000 * Math.sign(((next.time || -1) - (prev.time || -1)));
        const t1 = 1000 * Math.sign(prev.obstacleOrder - next.obstacleOrder);
        const t2 = 100 * Math.sign(prev.progressOrder - next.progressOrder)
        const t3 = 10 * Math.sign(((next.frequency || -1) - (prev.frequency || -1)))
        return t + t1 + t2 + t3;
      });
      return sortedIssueList;
    },
    options() {
      const [obstacleArr, obstacleMap] = this.getOptWithMap(this.meta.obstacle);
      const [progressArr, progressMap] = this.getOptWithMap(this.meta.progress);
      
      const _gameplay_dict = {}
      const _gameplays = []
      const _type_dict = {}
      const _types = []
      const _designer_dict = {}
      const _designers = []
      this.issueList.forEach(row=>{
        if(!_gameplay_dict[row.mode]) {
          _gameplay_dict[row.mode] = true
          _gameplays.push({label: row.mode, value: row.mode})
        }
        if(!_type_dict[row.type]) {
          _type_dict[row.type] = true
          _types.push({label: row.type, value: row.type})
        }
        if(row.designer) {
          const _ds = row.designer.split('/')
          _ds.forEach(d=>{
            d=d.trim()
            if(!_designer_dict[d]) {
              _designer_dict[d] = true
              _designers.push({label: d, value: d})
            }
          })
        }
      })
      
      const name = this.$store.state.user.name
      if(this.init && name && _designers.length>0) {
        const i = _designers.findIndex(d=>d.label===name)
        if(i >=0 ) {
          this.filter.designer=[this.$store.state.user.name]
        }
        this.init = false
      }
      return {
        dates: [
          { id: '', label: '全部' },
          { id: `${moment().subtract(7, 'days').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`, label: '近7天' },
          { id: `${moment().subtract(1, 'months').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`, label: '近一个月' },
          { id: `${moment().subtract(3, 'months').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`, label: '近三个月' },
        ],
        obstacle: [
          { id: 'all', label: '全部' },
          ...obstacleArr
        ],
        progress: [
          { id: 'all', label: '全部' },
          ...progressArr
        ],
        mode: _gameplays,
        designer: _designers,
        type: _types,
        obstacleMap,
        progressMap,
        obstacleN: obstacleArr.map(o=>({value:o.id, label:o.label})),
        progressN: progressArr.map(o=>({value:o.id, label:o.label}))
      }
    },
    progressOptions() {
      const [progressArr] = this.getOptWithMap(this.meta.progress);
      return progressArr;
    }
  },
  methods: {
    disabledRangeDate(current) {
      return current && current > moment().endOf('day');
    },    
    getExperienceIssue() {
      this.loading = true;
      this.$service.query_fixed_module(this.api).then(res => {
        this.loading = false;
        if (res.data) {
          const name = this.$store.state.user.name
          if(name=='邱逸桐') {
            this.issueList = (res.data.list || []).filter(i=>i.designer && i.designer.indexOf('邱逸桐') >=0)
          }
          else {
            this.issueList = res.data.list || [];
          }
          this.meta.obstacle = res.data.meta.obstacle || [];
          this.meta.progress = res.data.meta.progress || [];
        }
      }).catch(() => {
        this.loading = false;
      });      
    },
    changeFilterDate(value) {
      const [start_date, end_date] = value;
      this.filter.date = `${start_date.format('YYYY-MM-DD')}|${end_date.format('YYYY-MM-DD')}`;
    },
    // getStrSortedNum(str, nilNum = -9) {
    //   if (isNil(str)) {
    //     return nilNum;
    //   }
    //   const numList = str.match(/^\d+/);
    //   if (numList) {
    //     return numList[0];
    //   } else {
    //     return 99;
    //   }
    // },
    getOptWithMap(list) {
      const tmpArr = [];
      const tmpMap = {};
      (list || []).forEach(l => {
        tmpArr.push({ id: l.value, label: l.value });
        tmpMap[l.value] = l;
      });
      return [tmpArr, tmpMap];
    },
    updateIssueList(issueList) {
      console.log('update')
      const issueDict = {}
      issueList.forEach(row=>{
        issueDict[row.issue_id] = row
      })
      this.issueList = this.issueList.map(d=>{
        return issueDict[d.issue_id]?{...issueDict[d.issue_id]}:{...d}
      })
    },
    download() {
      this.$refs.issueTable.exportToExcel('问题清单')
    }
    
  }
}
</script>

<style lang="less">
.ux-issue-wrap {
  .issue-panel {
    padding-bottom: 20px;
    &.data-panel {
      margin-top: 0;
    }
    .ux-filter-title {
      display: inline-block;
      text-align: right;
      width: 64px;
      margin: 0 12px;
      font-weight: bold;
    }
    .data-panel-content {
      padding-top: 12px;
    }
  }
  .meta-span {
    display: inline-block;
    border-radius: 6px;
    padding: 1px 6px;
    font-size: 12px;
    background-color: #c4c4c4;
  }
  .remark-text {
    white-space: pre-line;
    text-align: left;
  }
  .remark-content {
    display: -webkit-box;
    // -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    max-width: 100%;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }
  .filter-wrap {
    display: flex;
    flex-wrap: wrap;
    
  }
  .filter {
    padding-bottom: 12px;
  }
  .ant-table-small>.ant-table-content>.ant-table-body {
    margin: 0;
  }
  .ant-table-thead > tr {
    background:#f2f2f2;
  }  
}

.ux-exp-tabs {
  padding-top: 20px;
  &.ant-tabs-card {
    .ant-tabs-content {
      margin-top: -16px;
      // .ant-tabs-tabpane {
      //   background: #fff;
      // }
    }
    .ant-tabs-bar {
      border-color: #fff;
      .ant-tabs-tab {
        border-color: transparent;
        background: transparent;
        font-size: 16px;
        font-weight: bold;
      }
      .ant-tabs-tab-active {
        border-color: #fff;
        background: #fff;
      }
    }
  }
}
</style>